import { StyledCompanyMetricField } from 'modules/components/layer01';
import { TabMetricSectionLayout } from 'modules/components/layer32';
import { useMemo } from 'react';
import * as ds from './dataService';


export type CompanyKeyInformationSectionProps = {
  listedCompanyId: string;
};

export const FC = (props: CompanyKeyInformationSectionProps) => {
  const { data, loading } = ds.useQuery(props.listedCompanyId);

  const fields = useMemo(() => [
    {
      label: 'Market capitalization (B)',
      value: data.marketCap
    },
    {
      label: '52-week stock price range',
      value: `${data.stock52Low} - ${data.stock52High}`
    },
    {
      label: 'Dividend yield (%)',
      value: `${data.divYield}`
    },
    {
      label: 'Basic shares outstanding (M)',
      value: `${data.sharesOutstanding}`
    },
    {
      label: 'Avg. Daily volume',
      value: `${data.avgDailyVolume}`
    },
    {
      label: 'First Trading Date ',
      value: data.firstTradingDate
    },
    {
      label: 'Sector',
      value: data.sector
    },
    {
      label: 'Industry',
      value: data.industry
    },
    {
      label: 'Employee count',
      value: data.employeeCount
    },
    {
      label: 'Next Earnings Report Date',
      value: data.nextEarningsReport
    }
  ], [data]);

  return (
    <TabMetricSectionLayout.FC
      title='Key Information'
    >
      {fields.map((field) => (
        <StyledCompanyMetricField.FC
          key={field.label}
          label={field.label}
          value={field.value}
          isLoading={loading}
        />
      ))}

    </TabMetricSectionLayout.FC>
  );
};
